import { render, staticRenderFns } from "./SalesBySegmentChart.vue?vue&type=template&id=28fc06b8&"
import script from "./SalesBySegmentChart.vue?vue&type=script&lang=js&"
export * from "./SalesBySegmentChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports